import { Tag } from '../../model/tagging/Tag';
import { Factory } from '../../services/Factory';
import { TagFormService } from '../../services/tagging/TagFormService';
import { TagFormElementTag } from '../../model/tagging/TagFormElementTag';
import { TagFormElementText } from '../../model/tagging/TagFormElementText';
import { RoleService } from '../../services/authentication/RoleService';
import { INotificationService } from '../../services/notification';

interface ITagFormScope extends any {
    formComponents: any[];
    tagAdmin: boolean;
    tagPagination: { categoryId: number, limit: number, page: number, totalPages: number, totalTags: number };
    roles: Array<any>;
    selectedRoleId: string;
  }

export class TagFormController {
  private scope: ITagFormScope;
  private tagFormService: TagFormService;
  private routeParams;
  private notificationService: INotificationService;

  constructor($scope: ITagFormScope, $routeParams, $uibModal, roleService: RoleService, tagFormService: TagFormService, notificationService: INotificationService) {
      this.scope = $scope;
      this.tagFormService = tagFormService;
      this.routeParams = $routeParams;
      this.notificationService = notificationService;

      $scope.formComponents = TagFormController.GetList();
      $scope.tagAdmin = true;
      $scope.tagPagination = {
        categoryId: 0,
        limit: 10,
        page: 1,
        totalPages: 1,
        totalTags: 0
      };
      $scope.roles = null;
      $scope.selectedRoleId = null;

      roleService.findByProjectId($routeParams.projectId, roles => {
        $scope.roles = roles;
        $scope.selectedRoleId = $scope.roles[0].id;
      });

      $scope.$watch("selectedRoleId", (roleId: string) => {
        if (roleId) {
          $scope.tagForm = null;
          tagFormService.findByProjectAndRole($routeParams.projectId, roleId, tagForm => {
            $scope.tagForm = tagForm;

            if (tagForm.elements) {
              tagForm.elements.forEach((e, index) => {
                if (e.tag) {
                  tagForm.elements[index] = {...new TagFormElementTag({...e}), ...e};
                }
              });
            }

            if (!$scope.tagForm.id) {
              $scope.tagForm = tagFormService.createTagForm($routeParams.projectId, roleId);
            }

            this.FetchTags();
          });
        }
      });

      $scope.sortableOptions = {
        placeholder: "admin-form-placeholder",
        connectWith: ".admin-tag-form",
        stop: (e, ui) => {
          // if the element is removed from the first container
          if ($(e.target).hasClass("first") &&
            ui.item.sortable.droptarget &&
            e.target !== ui.item.sortable.droptarget[0]) {
            // clone the original model to restore the removed item
            $scope.formComponents = TagFormController.GetList();
          } else if (_.filter($scope.tagForm.elements, (e: any) => e.editMode).length <= 0) {
            $scope.saveTagForm();
          }
        }
      };

      $scope.sortableOptions2 = {
        placeholder: "admin-form-placeholder",
        connectWith: ".admin-tag-form",
        stop: (e, ui) => {
          // if the element is removed from the first container
          if ($(e.target).hasClass("tagList") &&
            ui.item.sortable.droptarget &&
            e.target !== ui.item.sortable.droptarget[0]) {
            // clone the original model to restore the removed item
            this.FetchTags();
          }

          if (_.filter($scope.tagForm.elements, (e: any) => e.editMode).length <= 0) {
            $scope.saveTagForm();
          }
        }
      };

      $scope.saveTagForm = () => {
        $scope.tagForm.saving = true;
        this.tagFormService.save($scope.tagForm, tagForm => {
          $scope.tagForm.elements.forEach((e, i) => {
            e.id = tagForm.elements[i].id;
          });
          $scope.tagForm.saving = false;
          $scope.tagForm.id = tagForm.id;
          $scope.TagFormForm.$setPristine();
          this.notificationService.addSuccess({
            title: "Tag Form Saved",
            timeout: 2500
          });
        }, () => {
        });
      };

      $scope.$on("RemoveTagOption", (evt, option) => {
        $scope.tagForm.elements = _.filter($scope.tagForm.elements, (o: any) => o.id !== option.id);
        this.FetchTags();
        $scope.saveTagForm();
      });

      $scope.$on("ItemAddedToForm", (e, params) => {
        $scope.tagForm.elements[params.index] = params.option;

        $scope.saveTagForm();
        this.FetchTags();
      });

      $scope.hideMe = () => $scope.tagForm && $scope.tagForm.elements && $scope.tagForm.elements.length > 0;

      $scope.$watch("tagPagination.page", val => val && this.FetchTags());

      $scope.openAddTagDialog = tag => {
        const modalInstance = $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/tagging/dialog_add_tag.html",
          controller: "AddTagModalCtrl",
          resolve: {
            project: function () {
              return $scope.project
            },
            tag: function () {
              return tag
            }
          }
        });

        modalInstance.result.then(tag => {
          let type: string;
          let inverseTag: Tag;

          if (tag.inverseObjects && tag.inverseObjects.length > 0) {
            type = "radio";
            inverseTag = tag.inverseObjects[0];
          } else {
            type = "checkbox";
          }

          const tagFormElementTag = {...new TagFormElementTag({...tag}), tag, tagId: tag.id, type, inverseTag};

          const index = _.findIndex($scope.tagForm.elements, {tagId: tag.id});
          if (index > -1) {
            $scope.tagForm.elements[index] = tagFormElementTag;
          } else {
            $scope.tagForm.elements.unshift(tagFormElementTag);
          }

          $scope.saveTagForm();
        });
      }
    }

  private FetchTags(page?: number) {
      const currentPage = page !== undefined ? page : this.scope.tagPagination.page;
      const ids = [];
      if (this.scope.tagForm) {
        this.scope.tagForm.elements.forEach((element, index) => {
          if (element.type === 'text') {
            this.scope.tagForm.elements[index] = {...new TagFormElementText({...element})};
          } else {
            this.scope.tagForm.elements[index] = {...new TagFormElementTag({...element})};
            if (element.tag)
              ids.push(element.tag.id);
            if (element.inverseTag)
              ids.push(element.inverseTag.id);
          }
        });
      }

      this.tagFormService.getTags(
        this.routeParams.projectId,
        this.scope.tagPagination.categoryId,
        ids,
        currentPage - 1,
        this.scope.tagPagination.limit,
        tagPage => {
          this.scope.tagsPage = tagPage;
          this.scope.tagPagination.totalTags = tagPage.totalTags;
          this.scope.tagPagination.totalPages = tagPage.totalPages;
        }
      );
    }

  private static GetList() {
      return [{
        title: "Radio",
        type: "radio",
        editMode: true
      }, {
        title: "Checkbox",
        type: "checkbox",
        editMode: true
      }, {
        title: "Text",
        type: "text",
        editMode: true
      }];
    }
  }

frontendApp.controller("TagFormController", ["$scope", "$routeParams", "$uibModal", "RoleService", "TagFormService", "NotificationService", Factory.Create(TagFormController)]);
